// extracted by mini-css-extract-plugin
module.exports = {"imageloader":"ImageLoader_imageloader__uABzD","shine":"ImageLoader_shine__oafwB"};